import { Injectable } from '@angular/core';

import { BasePageMetaResolver } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DpBasePageMetaResolver extends BasePageMetaResolver {
  protected metaTitle$: Observable<string | undefined> = this.page$.pipe(map((p) => p.metaTitle));

  resolveMetaTitle(): Observable<string | undefined> {
    return this.metaTitle$;
  }
}
